import mitt, { Emitter } from 'mitt'
import { createContext, ReactNode, useContext } from 'react'

export type Events = {
  addCartProduct: void;
};

const emitter: Emitter<Events> = mitt<Events>()

export interface EmitterContextType {
  emitter: Emitter<Events>;
}

const EmitterContext = createContext<EmitterContextType>({ emitter })

interface EmitterProviderProps {
  children?: ReactNode;
}

export const EmitterProvider = ({ children = null }: EmitterProviderProps) => {
  return (
    <EmitterContext.Provider value={{ emitter }}>
      {children}
    </EmitterContext.Provider>
  )
}

export const useEmitter = (): EmitterContextType => useContext(EmitterContext)
